import React, { memo } from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

function EmailComponent({ value }) {
  return <span className={`${styles.text} ellipsis`}>{value}</span>;
}

EmailComponent.propTypes = {
  value: PropTypes.string
};

export const Email = memo(EmailComponent);
